import React, { memo, useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import PanToolRoundedIcon from "@mui/icons-material/PanToolRounded";
import NotiIcon from "../components/image/NotiIcon";
import { UnreadCard } from "../components/image";
import WeekdaysItem from "../components/dashBoard/WeekdaysItem";
import { getNameInCapitalize, renderTime, urlify } from "../utils/common";
import { EmptyText, RichText } from "../components/common/CellText";
import MainLayout from "../layouts/MainLayout";
import EmptyData from "../components/image/EmptyData";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import NotificationPage from "./NotificationPage";
import { ACL_ACTION_TYPE, MODULE_CODE } from "../utils/constants";
import Message from './../components/common/Message';
import moment from 'moment';
import GreetingTag from "../components/GreetingTag";

const DashboardPage = ({
    dashBoardStore,
    authenticationStore,
    workScheduleStore,
    moduleStore,
    aclStore,
    notificationStore,
}) => {
    const { getSideMenuCounterDashboard, dashboardSideMenuCounter } =
        dashBoardStore;
    const date = new Date();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const { workScheduleList, getWorkSchedule } = workScheduleStore;
    const navigate = useNavigate();
    const { currentUser, isAccountAdmin, isSuperAdmin } = authenticationStore;
    const [openMessage, setOpenMessage] = useState(false);
    useEffect(() => {
        (async () => {
            try {
                // setIsLoadingSidemenuCounter(true)
                await Promise.all([
                    getSideMenuCounterDashboard(["WORK"]),
                    getSideMenuCounterDashboard(["PROPOSAL"]),
                    getSideMenuCounterDashboard(["INCOMING"]),
                    getSideMenuCounterDashboard(["OUTGOING"]),
                    getSideMenuCounterDashboard(["TASK"]),
                ]);
            } catch (err) {
                console.log(err);
                // message.error(err.vi || 'Đã có lỗi xảy ra!')
                // setIsLoadingSidemenuCounter(false)
            } finally {
                // setIsLoadingSidemenuCounter(false)
            }
        })();
    }, []);
    useEffect(() => {
        getWorkSchedule(
            selectedDate.toISOString().split("T")[0],
            selectedDate.toISOString().split("T")[0]
        );
    }, [selectedDate]);

    // api thông báo check xem đọc chưa
    useEffect(() => {
        notificationStore.getUnreadNotificationCount()
        notificationStore.getUnreadNewsCount()
    }, [])
    let unreadSystem = notificationStore.unreadNotificationCount;
    let unreadGeneral = notificationStore.unreadNewsCount;

    const counterDisplay = (counter) => {
        if (counter > 9) return "9+";
        return counter;
    };

    let curr = new Date();
    let weekdays = [];

    for (let i = 1; i <= 7; i++) {
        let first = curr.getDate() - curr.getDay() + i;
        let day = new Date(curr.setDate(first));
        weekdays.push(day);
    }

    // Dialog
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const isAccessControl = (moduleCode, accessControlType) => {
        if (isSuperAdmin) return true;
        if (!moduleStore.checkAccessModule(moduleCode)) return false;
        if (accessControlType)
            return (
                isAccountAdmin ||
                !!aclStore.aclActionsByUser.find(
                    (item) => item.code === accessControlType
                )?.status
            );
        return true;
    };

    return (
        <MainLayout initialValue={0}>
            <div className=" px-7">
                <header className="flex items-center justify-between">
                    <div>
                        <GreetingTag />
                        <div className="mt-2 font-medium">
                            Đ/c{" "}
                            <span className="font-bold text-[28px] leading-7">
                                {currentUser &&
                                    getNameInCapitalize(
                                        currentUser.name_uppercase
                                    )}
                            </span>
                        </div>
                    </div>
                    <div>
                        <div
                            className="cursor-pointer"
                            onClick={handleClickOpen}
                        >
                            <NotiIcon unreadSystem={unreadSystem} unreadGeneral={unreadGeneral} />
                        </div>
                        <Dialog
                            fullScreen={fullScreen}
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="responsive-dialog-title"
                        >
                            <NotificationPage handleClose={handleClose} />
                        </Dialog>
                    </div>
                </header>
                <section className="relative overflow-hidden mt-[18px] bg-[#0073C7] text-white rounded-lg px-5 py-4 flex justify-between items-center">
                    <img
                        srcSet="/images/Vector195.png 2x"
                        alt="bg"
                        className="absolute bottom-0 left-0 isolate"
                    />
                    <div>
                        <div className="text-xs font-medium leading-[18px]">
                            <div>
                                {" "}
                                {+date.getDay() + 1 === 1
                                    ? "Chủ nhật"
                                    : `Thứ ${+date.getDay() + 1}`}
                            </div>
                            <div>
                                {`0${date.getDate()}`.slice(-2)} tháng{" "}
                                {`0${date.getMonth() + 1}`.slice(-2)},
                                {date.getFullYear()}
                            </div>
                        </div>
                        <div className="overflow-hidden px-2 -mx-2 h-[128px] inline-flex">
                            <div className="flex flex-col slide1 flex-nowrap">
                                <div className="mt-3 font-bold text-[28px] leading-9 max-w-[135px] ">
                                    Bạn có{" "}
                                    {counterDisplay(
                                        Object.values(
                                            dashboardSideMenuCounter
                                        ).reduce((a, b) => a + b, 0)
                                    )}{" "}
                                    tài liệu chưa đọc
                                </div>
                                <div className="mt-4 text-sm">
                                    <div onClick={() => navigate('/internal-document/incoming-document')}>
                                        <span className="text-3xl font-semibold ">
                                            {counterDisplay(
                                                dashboardSideMenuCounter?.unread_incoming ??
                                                0
                                            )}
                                        </span>{" "}
                                        văn bản đến
                                    </div>
                                    <div onClick={() => navigate('/internal-document/outgoing-document')}>
                                        <span className="text-3xl font-semibold ">
                                            {counterDisplay(
                                                dashboardSideMenuCounter?.unread_outgoing ??
                                                0
                                            )}
                                        </span>{" "}
                                        văn bản đi
                                    </div>
                                    <div onClick={() => { setOpenMessage(true) }}>
                                        <span className="text-3xl font-semibold ">
                                            {counterDisplay(
                                                dashboardSideMenuCounter?.proposal_other ??
                                                0
                                            )}
                                        </span>{" "}
                                        Đơn hành chính
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Message
                        message="Tính năng đang phát triển"
                        openMessage={openMessage}
                        closeMessage={() => {
                            setOpenMessage(false);
                        }}
                    />
                    <UnreadCard />
                </section>
                <section className="flex justify-between mt-5 flex-nowrap">
                    {isAccessControl(
                        MODULE_CODE.nhiem_vu,
                        ACL_ACTION_TYPE.menu__MISSION
                    ) && (
                            <div className="px-4 py-8 bg-[rgba(199,0,0,0.1)] w-[calc(50%-14px)] rounded-lg" onClick={() => navigate('/mission')}>
                                <div className="text-center text-[42px] font-bold text-[#FF1010]">
                                    {counterDisplay(
                                        dashboardSideMenuCounter?.overdue_task
                                    ) ?? 0}
                                </div>
                                <div className="text-[16px] leading-4 font-semibold text-[#161616]">
                                    Nhiệm vụ
                                </div>
                                <div className="text-xs font-medium text-[#C70000]  mt-2">
                                    Quá hạn
                                </div>
                            </div>
                        )}
                    {isAccessControl(
                        MODULE_CODE.hanh_chinh,
                        ACL_ACTION_TYPE.menu__PROPOSAL
                    ) && (
                            <div className="px-4 py-8 bg-[rgba(0,115,199,0.1)] w-[calc(50%-14px)] rounded-lg" onClick={() => setOpenMessage(true)}>
                                <div className="text-center text-[42px] font-bold text-[#1089FF]">
                                    {counterDisplay(
                                        dashboardSideMenuCounter?.proposal_other ??
                                        0
                                    )}
                                </div>
                                <div className="text-[16px] leading-4 font-semibold text-[#161616]">
                                    Đơn hành chính
                                </div>
                                <div className="text-xs font-medium text-[#1089FF]  mt-2">
                                    Cần giải quyết
                                </div>
                            </div>
                        )}
                </section>
                {isAccessControl(
                    MODULE_CODE.lich_co_quan,
                    ACL_ACTION_TYPE.menu__WORK_SCHEDULE
                ) && (
                        <section>
                            <div className="text-lg mt-[18px] font-semibold leading-5">
                                Lịch cơ quan
                            </div>
                            <div className="flex justify-between gap-4 overflow-x-auto mt-[18px] hideScrollbar">
                                {weekdays.map((item) => (
                                    <WeekdaysItem
                                        day={item.getDay() + 1}
                                        date={item.getDate()}
                                        selectedDate={selectedDate}
                                        onClick={() => {
                                            setSelectedDate(item);
                                        }}
                                    />
                                ))}
                            </div>
                            {!(workScheduleList?.length > 0) ? (
                                <EmptyData />
                            ) : (
                                <div className="my-[18px] [&>*:nth-child(odd)]:bg-[#F8F8F8]">
                                    {workScheduleList?.map((item) => (
                                        <div className=" p-4  text-sm leading-[15px]" onClick={() => navigate(`/company-work-schedule/view/${item.schedule_code}`)}>
                                            <div className="mb-3">
                                                <div className="font-semibold">
                                                    <span className=" text-[#161616]">
                                                        Thời gian:
                                                    </span>{" "}
                                                    <span className=" text-primary">
                                                        {item.end_at
                                                            ? `${renderTime(
                                                                item.start_at
                                                            )} - ${renderTime(
                                                                item.end_at
                                                            )}`
                                                            : renderTime(
                                                                item.start_at
                                                            )}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="flex justify-between">
                                                <div className="w-[calc(50%-8px)] text-[#737373]">
                                                    <div className="font-semibold text-[#161616] mb-1">
                                                        Nội dung:
                                                    </div>
                                                    <div className=" font-normal leading-[22px] break-all">
                                                        <RichText
                                                            text={
                                                                item?.event_notice
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="w-[calc(50%-8px)]">
                                                    <div className="font-semibold text-[#161616] mb-1">
                                                        Địa điểm:{" "}
                                                    </div>
                                                    <div>
                                                        {item?.location ? (
                                                            <RichText
                                                                text={urlify(
                                                                    item?.location
                                                                )}
                                                            />
                                                        ) : (
                                                            <EmptyText>
                                                                Không có địa điểm.
                                                            </EmptyText>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </section>
                    )}
            </div>
        </MainLayout>
    );
};

export default memo(
    inject(
        "dashBoardStore",
        "authenticationStore",
        "workScheduleStore",
        "notificationStore",
        "moduleStore",
        "aclStore"
    )(observer(DashboardPage))
);
